import { useEffect, useRef, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/context/AuthContext';

const DISMISSED_KEY = 'sample_game_dismissed';

export const useSampleGame = () => {
  const { user } = useAuth();
  const hasChecked = useRef(false);
  const [sampleGameVersion, setSampleGameVersion] = useState(0);

  useEffect(() => {
    if (!user || hasChecked.current) return;
    hasChecked.current = true;

    const ensureSampleGame = async () => {
      // Skip if user previously dismissed the sample game
      if (localStorage.getItem(DISMISSED_KEY) === 'true') return;

      // Skip if user already has ANY games (existing user)
      const { data: existingGames } = await supabase
        .from('game_players')
        .select('game_id')
        .eq('player_id', user.id)
        .limit(1);

      if (existingGames && existingGames.length > 0) {
        // Existing user — mark as dismissed so we never check again
        localStorage.setItem(DISMISSED_KEY, 'true');
        return;
      }

      // New user — create sample game via RPC
      const { error } = await supabase.rpc('create_sample_game', {
        p_user_id: user.id,
      });

      if (error) {
        console.error('useSampleGame - Failed to create sample game:', error);
        return;
      }

      // Signal that a new game was created so consumers can refetch
      setSampleGameVersion(v => v + 1);
    };

    ensureSampleGame();
  }, [user]);

  return { sampleGameVersion };
};
